import VueRouter from 'vue-router'

import AboutPage from './pages/AboutPage'
import HomePage from './pages/HomePage'
import AfricaPage from './pages/AfricaPage'
import TravelPage from './pages/TravelPage'
import USTravelPage from './pages/USTravelPage'
import CorrelationMapPage from './pages/CorrelationMapPage'
import GovPage from './pages/GovPage'

let homeComponent = HomePage

if (window.location.href.indexOf('//travel.') != -1) {
  homeComponent = TravelPage
} else if (window.location.href.indexOf('//us-travel.') != -1) {
  homeComponent = USTravelPage
} else if (window.location.href.indexOf('//ustravel.') != -1) {
  homeComponent = USTravelPage
} else if (window.location.href.indexOf('//africa.') != -1) {
  homeComponent = AfricaPage
}
const routes = [
  { path: '/about', component: AboutPage },
  { path: '/home', component: HomePage },
  { path: '/africa', component: AfricaPage },
  { path: '/travel', component: TravelPage },
  { path: '/us-travel', component: USTravelPage },
  { path: '/government', component: GovPage },
  { path: '/viz', component: CorrelationMapPage },
  { path: '/', component: homeComponent },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router;
